export const SET_USER_DATA = 'user/SET_USER_DATA';
export const SET_AUTHENTICATING = 'user/SET_AUTHENTICATING';
export const SET_TOC_RESULTS = 'user/SET_TOC_RESULTS';